<template>
    <div>
        <nav class="bg-white border-b">
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div class="flex items-center justify-between h-16">
                    <div class="flex items-center">
                        <div class="flex-shrink-0">
                            <router-link to="/message_type">
                                <svg class="h-8 w-8" fill="none" viewBox="0 0 35 32" xmlns="http://www.w3.org/2000/svg">
                                    <path fill="#38a275" d="M15.258 26.865a4.043 4.043 0 01-1.133 2.917A4.006 4.006 0 0111.253 31a3.992 3.992 0 01-2.872-1.218 4.028 4.028 0 01-1.133-2.917c.009-.698.2-1.382.557-1.981.356-.6.863-1.094 1.47-1.433-.024.109.09-.055 0 0l1.86-1.652a8.495 8.495 0 002.304-5.793c0-2.926-1.711-5.901-4.17-7.457.094.055-.036-.094 0 0A3.952 3.952 0 017.8 7.116a3.975 3.975 0 01-.557-1.98 4.042 4.042 0 011.133-2.918A4.006 4.006 0 0111.247 1a3.99 3.99 0 012.872 1.218 4.025 4.025 0 011.133 2.917 8.521 8.521 0 002.347 5.832l.817.8c.326.285.668.551 1.024.798.621.33 1.142.826 1.504 1.431a3.902 3.902 0 01-1.504 5.442c.033-.067-.063.036 0 0a8.968 8.968 0 00-3.024 3.183 9.016 9.016 0 00-1.158 4.244zM19.741 5.123c0 .796.235 1.575.676 2.237a4.01 4.01 0 001.798 1.482 3.99 3.99 0 004.366-.873 4.042 4.042 0 00.869-4.386 4.02 4.02 0 00-1.476-1.806 3.994 3.994 0 00-5.058.501 4.038 4.038 0 00-1.175 2.845zM23.748 22.84c-.792 0-1.567.236-2.226.678a4.021 4.021 0 00-1.476 1.806 4.042 4.042 0 00.869 4.387 3.99 3.99 0 004.366.873A4.01 4.01 0 0027.08 29.1a4.039 4.039 0 00-.5-5.082 4 4 0 00-2.832-1.18zM34 15.994c0-.796-.235-1.574-.675-2.236a4.01 4.01 0 00-1.798-1.483 3.99 3.99 0 00-4.367.873 4.042 4.042 0 00-.869 4.387 4.02 4.02 0 001.476 1.806 3.993 3.993 0 002.226.678 4.003 4.003 0 002.832-1.18A4.04 4.04 0 0034 15.993z"/>
                                    <path fill="#38a275" d="M5.007 11.969c-.793 0-1.567.236-2.226.678a4.021 4.021 0 00-1.476 1.807 4.042 4.042 0 00.869 4.386 4.001 4.001 0 004.366.873 4.011 4.011 0 001.798-1.483 4.038 4.038 0 00-.5-5.08 4.004 4.004 0 00-2.831-1.181z"/>
                                </svg>
                            </router-link>
                        </div>
                        <div class="hidden md:block">
                            <div class="ml-10 flex items-baseline space-x-4">
                                <router-link to="/contact_lists" class="px-3 py-2 rounded text-sm font-medium text-gray-700 hover:text-gray-900 focus:outline-none focus:text-green-500">Contact Lists</router-link>
                                <router-link to="/callback_number" class="px-3 py-2 rounded text-sm font-medium text-gray-700 hover:text-gray-900 focus:outline-none focus:text-green-500">Callback No</router-link>
                                <router-link to="/reports" class="px-3 py-2 rounded text-sm font-medium text-gray-700 hover:text-gray-900 focus:outline-none focus:text-green-500">Reports</router-link>
                            </div>
                        </div>
                    </div>

                    <div class="hidden md:block">
                        <div class="ml-4 flex items-center md:ml-6">
                            <AccountDropdown />
                        </div>
                    </div>

                    <div class="-mr-2 flex md:hidden">
                        <!-- Mobile menu button -->
                        <button @click="isOpen = !isOpen" class="inline-flex items-center justify-center p-2 rounded-sm text-gray-400 hover:text-white hover:bg-green-500 focus:outline-none">
                            <svg class="h-6 w-6 fill-current" viewBox="0 0 24 24">
                                <path
                                    v-if="isOpen"
                                    fill-rule="evenodd"
                                    d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z"
                                />
                                <path v-if="!isOpen" fill-rule="evenodd" d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>

            <div :class="isOpen ? 'block' : 'hidden'" class="md:hidden border-b-2">
                <div class="px-2 pt-2 pb-3 space-y-1 sm:px-3">
                    <a href="#" class="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 focus:outline-none">Contact Lists</a>
                    <a href="#" class="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 focus:outline-none">Callback No</a>
                    <a href="#" class="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 focus:outline-none">Reports</a>
                </div>
                <div class="pt-4 pb-3 border-t border-gray-400">
                    <div class="flex items-center px-5 space-x-3">
                        <div class="flex-shrink-0">
                            <img class="h-10 w-10 rounded-full" src="../assets/images/user.png" alt="" />
                        </div>
                        <div class="space-y-1">
                            <div class="text-base font-medium leading-none text-white">User Name</div>
                            <div class="text-sm font-medium leading-none text-gray-400">user@user.com</div>
                        </div>
                    </div>
                    <div class="mt-3 px-2 space-y-1">
                        <a href="#" class="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 focus:outline-none">Account</a>
                        <a href="#" class="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 focus:outline-none">Settings</a>
                        <a href="#" @click.prevent="signout" class="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 focus:outline-none">Sign out</a>
                    </div>
                </div>
            </div>
        </nav>
    </div>
</template>

<script>
    import AccountDropdown from "./AccountDropdown";

    export default {
        components: {
            AccountDropdown,
        },
        data() {
            return {
                isOpen: false,
            };
        },
        methods: {
            signout() {
                this.$store.dispatch("logout")
                    .then(() => {
                        this.$router.push("/login")
                    });
            }
        }
    };
</script>
